export default {
  'vip.exchange.title': 'VIP Growth Value Exchange Configuration',
  'vip.exchange.ruleTitle': 'VIP Rules Description',
  'vip.exchange.currency': 'Currency',
  'vip.exchange.amount': 'Amount',
  'vip.exchange.growthValue': 'VIP Growth Value',
  'vip.exchange.enterAmount': 'Please enter amount',
  'vip.exchange.enterGrowthValue': 'Please enter growth value',
  'vip.exchange.enterValidNumber': 'Please enter a valid number (up to 2 decimal places)',
  'vip.exchange.enterPositiveInteger': 'Please enter a positive integer',
  'vip.exchange.refresh': 'Refresh',
  'vip.exchange.save': 'Save',
  'vip.exchange.saveSuccess': 'Save successful',
  'vip.exchange.saveFailed': 'Save failed, please check input',
  'vip.exchange.dataLoadFailed': 'Data load failed',
  'vip.exchange.ruleContent': 'Please enter VIP rules description',
  'vip.exchange.ruleContentRequired': 'Please enter VIP rules description',
  'vip.log.grow.title': 'VIP Growth Value Records',
  'vip.log.level.title': 'VIP Change Records',
  'vip.log.memberAccount': 'Member Account',
  'vip.log.level': 'VIP Level',
  'vip.log.changeReason': 'Change Reason',
  'vip.log.beforeGrow': 'VIP Growth Value Before Change',
  'vip.log.grow': 'VIP Growth Value Change',
  'vip.log.afterGrow': 'VIP Growth Value After Change',
  'vip.log.createTime': 'Create Time',
  'vip.log.changeTime': 'Change Time',
  'vip.log.changeType': 'Change Type',
  'vip.log.beforeLevel': 'Before Change',
  'vip.log.afterLevel': 'After Change',
  'vip.log.operator': 'Operator',
  'vip.log.upgrade': 'Upgrade',
  'vip.log.downgrade': 'Downgrade',
  'vip.log.enterMemberAccount': 'Please enter member account',
  'vip.log.selectChangeType': 'Please select change type',
  'vip.setup.condition.title': 'VIP Condition Settings',
  'vip.setup.unifiedReward.title': 'VIP Unified Reward Configuration',
  'vip.setup.reward.title': 'VIP Reward Settings',
  'vip.setup.point.title': 'VIP Point Settings',
  'vip.setup.withdrawLimit.title': 'VIP Withdrawal Limit Settings',
  'vip.setup.upgradeReward': 'Upgrade Reward',
  'vip.setup.flowMultiple': 'Turnover Multiple',
  'vip.setup.retentionReward': 'Retention Reward',
  'vip.setup.weeklySalary': 'Weekly Salary',
  'vip.setup.weeklyRequiresDeposit': 'Required Deposit',
  'vip.setup.weeklyRequiresBetflow': 'Required Turnover',
  'vip.setup.monthlySalary': 'Monthly Salary',
  'vip.setup.monthlyRequiresDeposit': 'Required Deposit',
  'vip.setup.monthlyRequiresBetflow': 'Required Turnover',
  'vip.setup.birthdayReward': 'Birthday Reward',
  'vip.setup.claimValidityDays': 'Claim Validity Days',
  'vip.setup.enterUpgradeReward': 'Please enter upgrade reward',
  'vip.setup.enterFlowMultiple': 'Please enter turnover multiple',
  'vip.setup.enterRetentionReward': 'Please enter retention reward',
  'vip.setup.enterWeeklySalary': 'Please enter weekly salary',
  'vip.setup.enterWeeklyRequiresDeposit': 'Please enter required deposit',
  'vip.setup.enterWeeklyRequiresBetflow': 'Please enter required turnover',
  'vip.setup.enterMonthlySalary': 'Please enter monthly salary',
  'vip.setup.enterMonthlyRequiresDeposit': 'Please enter required deposit',
  'vip.setup.enterMonthlyRequiresBetflow': 'Please enter required turnover',
  'vip.setup.enterBirthdayReward': 'Please enter birthday reward',
  'vip.setup.enterClaimValidityDays': 'Please enter claim validity days',
  'vip.setup.upgradePoint': 'Upgrade Points',
  'vip.setup.retentionPoint': 'Retention Points',
  'vip.setup.appDayPoint': 'APP Daily Points',
  'vip.setup.h5DayPoint': 'H5 Daily Points',
  'vip.setup.verifyMobile': 'Mobile Verification',
  'vip.setup.enterUpgradePoint': 'Please enter upgrade points',
  'vip.setup.enterRetentionPoint': 'Please enter retention points',
  'vip.setup.enterAppDayPoint': 'Please enter APP daily points',
  'vip.setup.enterH5DayPoint': 'Please enter H5 daily points',
  'vip.setup.upgradeGrow': 'Upgrade Growth Value ≥',
  'vip.setup.retentionGrow': 'Retention Growth Value ≥',
  'vip.setup.retentionDays': 'Retention Validity Days',
  'vip.setup.unlimited': 'Permanent',
  'vip.setup.enterUpgradeGrow': 'Please enter upgrade growth value',
  'vip.setup.enterRetentionGrow': 'Please enter retention growth value',
  'vip.setup.enterRetentionDays': 'Please enter retention validity days',
  'vip.exchange.pageSubtitle': 'Configure growth value exchange ratio for deposit amount and valid turnover by currency, with independent switch control',
  'vip.exchange.depositChannel': 'Deposit Exchange Channel',
  'vip.exchange.depositChannelDesc': 'Real-time conversion upon deposit',
  'vip.exchange.betflowChannel': 'Turnover Exchange Channel',
  'vip.exchange.betflowChannelDesc': 'Page trigger + polling async conversion',
  'vip.exchange.enabled': 'Enabled',
  'vip.exchange.disabled': 'Disabled',
  'vip.exchange.depositAmount': 'Deposit Amount',
  'vip.exchange.depositGrowthValue': 'VIP Growth Value',
  'vip.exchange.betflowAmount': 'Valid Turnover Amount',
  'vip.exchange.betflowGrowthValue': 'VIP Growth Value',
  'vip.exchange.description': 'Description',
  'vip.exchange.enterBetflowAmount': 'Please enter valid turnover amount',
  'vip.exchange.enterBetflowGrowthValue': 'Please enter turnover growth value',
  'vip.exchange.descDeposit': 'Per {{amount}} {{currency}} deposit = {{grow}} growth value',
  'vip.exchange.descBetflow': 'Per {{amount}} {{currency}} valid turnover = {{grow}} growth value',
  'vip.exchange.previewSaveData': 'Preview save data',
  'vip.exchange.formValidationFailed': 'Form validation failed',
  'vip.setup.level': 'VIP Level',
  'vip.setup.upgradeGrowValidation': 'VIP{currentLevel} upgrade growth value ({currentValue}) must be greater than VIP{prevLevel} upgrade growth value ({prevValue})',
  'vip.setup.retentionGrowValidation': 'VIP{currentLevel} retention growth value ({currentValue}) must be greater than VIP{prevLevel} retention growth value ({prevValue})',
  'vip.log.memberAccountRequired': 'Member account cannot be empty',
  'vip.log.dataLoadFailed': 'Data load failed',
  'vip.withdrawLimit.dailyLimit': 'Daily Withdrawal Limit',
  'vip.withdrawLimit.enterWithdrawLimit': 'Please enter withdrawal limit',
  'vip.withdrawLimit.enterValidAmount': 'Please enter valid amount (decimal or -1 for unlimited)',
  'vip.withdrawLimit.unlimited': 'Unlimited',
  'vip.withdrawLimit.unlimitedHint': '-1=Unlimited',
  'vip.withdrawLimit.enableVipWithdraw': 'Enable VIP Limit',
  'vip.setup.ticket.title': 'VIP Ticket Settings',
  'vip.setup.ticket.upgradeQuantity': 'Ticket Quantity',
  'vip.setup.ticket.enterTicketNumber': 'Please enter ticket quantity',
  'vip.setup.ticket.enterValidTicketNumber': 'Please enter valid ticket quantity (decimal or -1 for unlimited)',
  'vip.setup.ticket.unlimitedHint': '-1=Unlimited',
  'vip.setup.ticket.upgradeTicket': 'VIP Upgrade Reward',
  'vip.setup.ticket.selectUpgradeTicket': 'Please select upgrade reward',
  'vip.setup.pointConfig.title': 'Point Configuration',
  'vip.setup.pointConfig.minPoint': 'Min Points',
  'vip.setup.pointConfig.maxPoint': 'Max Points',
  'vip.setup.pointConfig.probability': 'Probability',
  'vip.setup.pointConfig.add': 'Add',
  'vip.setup.pointConfig.delete': 'Delete',
  'vip.setup.pointConfig.save': 'Confirm',
  'vip.setup.pointConfig.cancel': 'Cancel',
  'vip.setup.pointConfig.minPointRequired': 'Please enter min points',
  'vip.setup.pointConfig.maxPointRequired': 'Please enter max points',
  'vip.setup.pointConfig.probabilityRequired': 'Please enter probability',
  'vip.setup.pointConfig.minPointInvalid': 'Min points must be a positive integer',
  'vip.setup.pointConfig.maxPointInvalid': 'Max points must be a positive integer',
  'vip.setup.pointConfig.maxLessThanMin': 'Max points cannot be less than min points',
  'vip.setup.pointConfig.probabilityInvalid': 'Probability must be a number between 0-100',
  'vip.setup.pointConfig.totalProbabilityError': 'Total probability must equal 100%, currently {total}%',
  'vip.setup.pointConfig.totalProbabilityWarning': 'Total probability must equal 100%',
  'vip.setup.pointConfig.setting': 'Setting',
  'vip.setup.pointConfig.totalProbability': 'Total Probability',
  'vip.setup.pointConfig.action': 'Action',
  'vip.setup.pointConfig.count': 'Count',
  'vip.setup.pointConfig.title': 'Point Configuration',
  'vip.setup.pointConfig.minPoint': 'Min Points',
  'vip.setup.pointConfig.maxPoint': 'Max Points',
  'vip.setup.pointConfig.probability': 'Probability',
  'vip.setup.pointConfig.add': 'Add',
  'vip.setup.pointConfig.delete': 'Delete',
  'vip.setup.pointConfig.save': 'Confirm',
  'vip.setup.pointConfig.cancel': 'Cancel',
  'vip.setup.pointConfig.minPointRequired': 'Please enter min points',
  'vip.setup.pointConfig.maxPointRequired': 'Please enter max points',
  'vip.setup.pointConfig.probabilityRequired': 'Please enter probability',
  'vip.setup.pointConfig.minPointInvalid': 'Min points must be a positive integer',
  'vip.setup.pointConfig.maxPointInvalid': 'Max points must be a positive integer',
  'vip.setup.pointConfig.maxLessThanMin': 'Max points cannot be less than min points',
  'vip.setup.pointConfig.probabilityInvalid': 'Probability must be a number between 0-100',
  'vip.setup.pointConfig.totalProbabilityError': 'Total probability must equal 100%, currently {total}%',
  'vip.setup.pointConfig.totalProbabilityWarning': 'Total probability must equal 100%',
  'vip.setup.pointConfig.setting': 'Setting',
  'vip.setup.pointConfig.totalProbability': 'Total Probability',
  'vip.setup.pointConfig.action': 'Action',

  
  // VIP Unified Reward Configuration
  'vip.unified.scene.upgrade': 'Upgrade Reward',
  'vip.unified.scene.retention': 'Retention Reward',
  'vip.unified.scene.weekly': 'Weekly Salary',
  'vip.unified.scene.monthly': 'Monthly Salary',
  'vip.unified.scene.birthday': 'Birthday Reward',
  'vip.unified.scene.appDaily': 'APP Daily',
  'vip.unified.scene.h5Daily': 'H5 Daily',
  'vip.unified.basicReward': 'Basic Rewards',
  'vip.unified.claimConditions': 'Claim Conditions',
  'vip.unified.rewardCurrency': 'Reward Currency',
  'vip.unified.reward': 'Reward',
  'vip.unified.point': 'Points',
  'vip.unified.ticket': 'Ticket',
  'vip.unified.flowMultiple': 'Turnover Multiple',
  'vip.unified.requiresDeposit': 'Required Deposit',
  'vip.unified.requiresBetflow': 'Required Turnover',
  'vip.unified.verifyMobile': 'Mobile Verification',
  'vip.unified.pointConfig': 'Point Configuration',
  'vip.unified.claimValidityDays': 'Claim Validity Days',
  'vip.unified.enterReward': 'Please enter reward',
  'vip.unified.enterPoint': 'Please enter points',
  'vip.unified.enterFlowMultiple': 'Please enter turnover multiple',
  'vip.unified.enterRequiresDeposit': 'Please enter required deposit',
  'vip.unified.enterRequiresBetflow': 'Please enter required turnover',
  'vip.unified.enterClaimValidityDays': 'Please enter validity days',
  'vip.unified.selectTicket': 'Please select ticket',
  'vip.unified.enterQuantity': 'Please enter quantity',
  'vip.unified.quantity': 'Quantity',

  // VIP Manual Adjustment
  'vip.adjust.title': 'Manual VIP Adjustment',
  'vip.adjust.singleTab': 'Single Adjust',
  'vip.adjust.batchTab': 'Batch Adjust',
  'vip.adjust.memberAccount': 'Member Account',
  'vip.adjust.enterMemberAccount': 'Enter member account and press Enter to search',
  'vip.adjust.enterMemberAccountRequired': 'Please enter member account',
  'vip.adjust.query': 'Search',
  'vip.adjust.account': 'Account',
  'vip.adjust.currentVip': 'Current VIP',
  'vip.adjust.growthValue': 'Growth Value',
  'vip.adjust.toNextLevel': 'To Next Level',
  'vip.adjust.maxLevel': 'Max Level',
  'vip.adjust.adjustType': 'Adjust Type',
  'vip.adjust.adjustGrow': 'Adjust Growth Value',
  'vip.adjust.adjustGrowDesc': 'Increase or decrease experience value',
  'vip.adjust.adjustLevel': 'Adjust VIP Level',
  'vip.adjust.adjustLevelDesc': 'Directly change VIP level',
  'vip.adjust.direction': 'Direction',
  'vip.adjust.increase': 'Increase(+)',
  'vip.adjust.decrease': 'Decrease(-)',
  'vip.adjust.adjustValueLabel': 'Adjust Value',
  'vip.adjust.positiveInteger': 'Positive integer',
  'vip.adjust.enterAdjustValue': 'Please enter growth value to adjust',
  'vip.adjust.exceedCurrentGrow': 'Deduction cannot exceed current growth value ({{value}})',
  'vip.adjust.targetLevel': 'Target VIP Level',
  'vip.adjust.selectTargetLevel': 'Please select target level',
  'vip.adjust.currentLevelTag': 'Current Level',
  'vip.adjust.targetLevelSame': 'Target level is the same as current level',
  'vip.adjust.levelThresholdInfo': 'VIP{{level}} starting growth value: {{threshold}}, growth value will be set to {{threshold}}',
  'vip.adjust.remark': 'Remark',
  'vip.adjust.remarkOptional': 'Optional, max 200 chars',
  'vip.adjust.remarkPlaceholder': 'e.g. Activity compensation, system error compensation, risk control deduction, etc.',
  'vip.adjust.changePreview': 'Change Preview',
  'vip.adjust.upgradeLabel': ' (Upgrade)',
  'vip.adjust.downgradeLabel': ' (Downgrade)',
  'vip.adjust.upgradeImpact': 'Upgrade Impact (changes will take effect immediately or by cycle)',
  'vip.adjust.downgradeImpact': 'Downgrade Impact (changes will take effect immediately or by cycle)',
  'vip.adjust.confirmTitle': 'Confirm Adjustment?',
  'vip.adjust.confirmOk': 'Confirm',
  'vip.adjust.cancel': 'Cancel',
  'vip.adjust.confirmExec': 'About to execute on member {{account}}:',
  'vip.adjust.confirmWarning': 'This operation takes effect immediately and records cannot be deleted.',
  'vip.adjust.submitSuccess': 'Adjustment successful, updated VIP data for {{account}}',
  'vip.adjust.submitFailed': 'Adjustment failed, please retry',
  'vip.adjust.requestFailed': 'Request failed, please retry',
  'vip.adjust.memberNotFound': 'Member not found, please verify account',
  'vip.adjust.queryFailed': 'Query failed, please retry',
  'vip.adjust.lookupFirst': 'Please search member account first',
  'vip.adjust.enterValue': 'Please enter adjust value',
  'vip.adjust.confirmBtn': 'Confirm Adjust',
  'vip.adjust.close': 'Close',
  'vip.adjust.manualAdjust': 'Manual Adjust',
  'vip.adjust.system': 'System',
  'vip.adjust.impact.upgradeReward': 'Upgrade Reward: Trigger VIP{{level}} reward (claimed levels not re-issued)',
  'vip.adjust.impact.withdrawLimit': 'VIP Withdrawal Limit: Immediately changed to VIP{{level}} limit',
  'vip.adjust.impact.retentionProtection': 'Retention Period: Recalculated from today',
  'vip.adjust.impact.pointMall': 'Point Mall/Lucky Wheel: Unlock VIP{{level}} qualification',
  'vip.adjust.impact.customerService': 'Customer Service Routing: Next chat routed by VIP{{level}}',
  'vip.adjust.impact.notification': 'In-app Message: Push upgrade notification',
  'vip.adjust.impact.noRecovery': 'Issued rewards/points not recovered, future follows VIP{{level}} standard',
  'vip.adjust.impact.withdrawLimitDown': 'VIP Withdrawal Limit: Immediately reduced to VIP{{level}} limit',
  'vip.adjust.impact.loseQualification': 'Point Mall/Lucky Wheel: Lose qualifications exceeding VIP{{level}}',
  'vip.adjust.impact.noNotification': 'In-app Message: No notification pushed',
  'vip.adjust.uploadFile': 'Please upload a file first',
  'vip.adjust.batchTaskCreated': 'Batch task created, Task ID: {{taskId}}',
  'vip.adjust.uploadFailed': 'Upload processing failed',
  'vip.adjust.uploadError': 'Upload failed, please retry',
  'vip.adjust.templateDownloading': 'Template downloading...',
  'vip.adjust.templateDownloadFailed': 'Template download failed',
  'vip.adjust.downloadTemplate': 'Download Import Template',
  'vip.adjust.templateGuide': 'Template Instructions',
  'vip.adjust.colName': 'Column',
  'vip.adjust.colRequired': 'Required',
  'vip.adjust.colDesc': 'Description',
  'vip.adjust.colExample': 'Example',
  'vip.adjust.colMemberAccountDesc': 'Same as backend member list',
  'vip.adjust.colAdjustTypeDesc': '1=Adjust Growth Value, 2=Adjust VIP Level',
  'vip.adjust.colAdjustTypeExample': '1',
  'vip.adjust.colDirectionRequired': 'Required when adjusting growth value',
  'vip.adjust.colDirectionDesc': '1=Increase, 2=Decrease; leave empty for level',
  'vip.adjust.colDirectionExample': '1',
  'vip.adjust.colValueDesc': 'Growth value=positive integer; Level=target level(0~30)',
  'vip.adjust.colRemarkRequired': 'No',
  'vip.adjust.colRemarkDesc': '≤200 chars, uses batch remark if empty',
  'vip.adjust.colRemarkExample': 'Activity compensation',
  'vip.adjust.uploadDragText': 'Click or drag to upload CSV file',
  'vip.adjust.uploadHint': 'Max 5000 records per batch, file ≤ 20MB',
  'vip.adjust.fileSizeLimit': 'File size cannot exceed 20MB',
  'vip.adjust.batchRemark': 'Batch Remark',
  'vip.adjust.batchRemarkOptional': 'Optional, shared for this batch',
  'vip.adjust.batchRemarkPlaceholder': 'e.g. March activity growth value compensation',
  'vip.adjust.batchCreatedTitle': 'Batch adjustment task created',
  'vip.adjust.batchCheckProgress': 'Task will execute asynchronously, check progress in "Batch Tasks" tab',
  'vip.adjust.confirmBatch': 'Confirm Batch Adjustment',
  'vip.adjust.yes': 'Yes',

  // VIP Batch Tasks
  'vip.batch.title': 'Batch Tasks',
  'vip.batch.taskId': 'Task ID',
  'vip.batch.fileName': 'File Name',
  'vip.batch.totalCount': 'Total',
  'vip.batch.success': 'Success',
  'vip.batch.fail': 'Failed',
  'vip.batch.status': 'Status',
  'vip.batch.batchRemark': 'Batch Remark',
  'vip.batch.operator': 'Operator',
  'vip.batch.createTime': 'Create Time',
  'vip.batch.completeTime': 'Complete Time',
  'vip.batch.action': 'Action',
  'vip.batch.pending': 'Pending',
  'vip.batch.processing': 'Processing',
  'vip.batch.completed': 'Completed',
  'vip.batch.failed': 'Failed',
  'vip.batch.unknown': 'Unknown',
  'vip.batch.refresh': 'Refresh',
  'vip.batch.failDetail': 'Fail Details',
  'vip.batch.refreshList': 'Refresh List',
  'vip.batch.fetchFailed': 'Failed to fetch task list',
  'vip.batch.statusRefreshed': 'Status refreshed',
  'vip.batch.refreshFailed': 'Refresh failed',
  'vip.batch.noFailDetail': 'No failure details to export',
  'vip.batch.exportSuccess': 'Export successful',
  'vip.batch.exportFailed': 'Export failed',

  // Member-specific daily withdrawal limit (FBMPLAY-1704)
  'vip.memberLimit.buttonTitle': 'Withdrawal Limit',
  'vip.memberLimit.modalTitle': 'Set Daily Withdrawal Limit',
  'vip.memberLimit.currency': 'Currency',
  'vip.memberLimit.mode': 'Daily Withdrawal Limit · Mode',
  'vip.memberLimit.modeVip': 'Use VIP level daily limit (default)',
  'vip.memberLimit.modeMember': 'Use member-specific daily limit',
  'vip.memberLimit.amount': 'Member-specific Daily Limit (/ day)',
  'vip.memberLimit.amountHint': 'May be higher or lower than the VIP default; -1 = unlimited; 0 is not allowed',
  'vip.memberLimit.diff': '{sign}{diff} vs VIP{level} default',
  'vip.memberLimit.diffSame': 'Same as VIP{level} default',
  'vip.memberLimit.diffVipUnlimited': 'VIP{level} default is unlimited',
  'vip.memberLimit.amountInvalid': 'Enter -1 or an amount greater than 0',
  'vip.memberLimit.enterAmount': 'Enter member-specific daily limit',
  'vip.memberLimit.unlimited': 'Unlimited',
  'vip.memberLimit.unlimitedCell': 'Unlimited (-1)',
  'vip.memberLimit.perDay': 'day',
  'vip.memberLimit.remark': 'Remark',
  'vip.memberLimit.enterRemark': 'Describe the reason for this change',
  'vip.memberLimit.effectHint': 'Takes effect immediately; today\'s withdrawn amount is unchanged, remaining quota is recalculated',
  'vip.memberLimit.saveSuccess': 'Saved',
  'vip.memberLimit.saveFailed': 'Save failed',
  'vip.memberLimit.memberAccount': 'Member Account',
  'vip.memberLimit.enterMemberAccount': 'Enter member account',
  'vip.memberLimit.statusActive': 'Active',
  'vip.memberLimit.statusDisabled': 'Disabled',
  'vip.memberLimit.operator': 'Operator',
  'vip.memberLimit.enterOperator': 'Enter operator',
  'vip.memberLimit.operateTime': 'Operated At',
  'vip.memberLimit.edit': 'Edit',
};
